import React, { memo } from 'react';
import ReactSelect from 'react-select';
import PropTypes from 'prop-types';
import './style.css';

const Select = ({ type, testId, hasError, components, className, ...rest }) => {
  return (
    <ReactSelect
      {...rest}
      testId={testId}
      classNamePrefix="select"
      components={{ IndicatorSeparator: () => null, ...components }}
      className={`javelin-select ${className} ${hasError ? 'error' : ''}`}
    />
  );
};

Select.propTypes = {
  testId: PropTypes.string,
  hasError: PropTypes.bool,
  className: PropTypes.string,
};
Select.defaultProps = {
  testId: 'javelin-select',
  hasError: false,
  className: '',
};

export default memo(Select);
